import {V2SwapExecution} from "@tinymanorg/tinyman-js-sdk";

export enum SignFlowStep {
  /** Waiting for txn to be signed by the user */
  WaitingForSign = "WAITING_FOR_SIGN",
  /** Sending the signed txn to the blockchain */
  SendingTxn = "SENDING_TXN",
  /** Txn was successfully sent to the blockchain */
  Success = "SUCCESS",
  /** An error occurred while signing or sending the txn */
  Error = "ERROR"
}

export type SignFlowState =
  | {
      step: SignFlowStep.WaitingForSign;
    }
  | {
      step: SignFlowStep.SendingTxn;
      signedTxns: Uint8Array[];
    }
  | {
      step: SignFlowStep.Success;
      data: V2SwapExecution;
    }
  | {
      step: SignFlowStep.Error;
      error: unknown;
    };
